var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 205.09 282.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 102.55,
    cy: 102.55,
    r: 48.98,
    transform: "translate(-13.42 15.46) rotate(-8.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.09,102.54C205.09,45.91,159.18,0,102.55,0S0,45.91,0,102.54c0,9.33,1.26,18.37,3.59,26.96,13.37,52.56,61.1,111.49,94.9,152.68,39.63-43.21,101.74-105.13,106.3-171.72v-.11s.1-1.29.1-1.29h0c.14-2.15.21-4.33.21-6.52ZM102.55,151.52c-27.05,0-48.98-21.93-48.98-48.98s21.93-48.98,48.98-48.98,48.98,21.93,48.98,48.98-21.93,48.98-48.98,48.98Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8544545c216efa87bbc8865c37b33cb7.svg";
export { ForwardRef as ReactComponent };